module.exports = __webpack_public_path__ + "assets/icon-close-component.01b946f8.svg";